/*
* 用户账户组件
*/

import { Component } from 'react';
import $ from 'jquery';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import {
    PlusOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import CNF from '../../incs/Config';

import Entity from './UserEntity';
import AccreditEntity from './UserAccreditEntity';
import UserAuthoritySetEntity from './UserAuthoritySetEntity';

const Option = Select.Option;
const MODULENAME = CNF.navItems[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].ptn;

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLists: this.props.dataLists,
            accreditOpen: false,
            authorityOpen: false,
        }
    }

    setAccreditOpen = (value) => { this.setState({ accreditOpen: value }); }
    setAuthorityOpen = (value) => { this.setState({ authorityOpen: value }); }
    update = (record) => { this.props.setIsModalOpen(true, record); }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        let uri = 'users/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                this.update(record);
                break;
            case CNF.actionName.ACCREDIT:
                console.log('授权');
                this.accredit(record);
                break;
            case '权限' + CNF.actionName.SET:
                this.authoritySet(record);
                break;
            case CNF.actionName.RESET:
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.username, action, MODULENAME, this.props.isRefresh, uri);
                break
            default:
                break;

        }
    }

    /**
     * 用户授权
     * @param {*} record 
     */
    accredit(record) {
        this.setState({
            record: record,
            accreditOpen: true,
        });
    }

    /**
     * 用户权限设置
     * @param {*} record 
     */
    authoritySet(record) {
        this.setState({
            record: record,
            authorityOpen: true,
        });
    }

    render() {
        const columns = [
            { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
            { title: '用户名', dataIndex: 'username', key: 'username', },
            { title: '电话', dataIndex: 'phone', key: 'phone', },
            { title: '邮箱', dataIndex: 'email', key: 'email', },
            { title: '姓', dataIndex: 'surname', key: 'surname', },
            { title: '名', dataIndex: 'name', key: 'name', },
            { title: '显示名', dataIndex: 'displayname', key: 'displayname', },
            { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
            {
                title: '', key: 'operation', width: CNF.tableOperationColumnWidth,
                render: (record) => GetDropdownActionName(this.props.btnLists, MODULENAME_PTN, record, this.operation)
            }
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: this.props.x }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
                <AccreditEntity
                    record={this.state.record}
                    open={this.state.accreditOpen}
                    setOpen={this.setAccreditOpen}
                    isRefresh={this.props.isRefresh}
                />
                <UserAuthoritySetEntity
                    record={this.state.record}
                    open={this.state.authorityOpen}
                    setOpen={this.setAuthorityOpen}
                />
            </div>
        );
    }
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            username: '',
            phone: '',
            email: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeUsername = (e) => { this.setState({ username: e.target.value.replace(/ /g, '') }); this.search(); }
    changePhone = (e) => { this.setState({ phone: e.target.value.replace(/ /g, '') }); this.search(); }
    changeEmail = (e) => { this.setState({ email: e.target.value.replace(/ /g, '') }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setIsModalOpen = (value, record) => { this.setState({ isModalOpen: value, record: record }); }
    create = () => { this.setIsModalOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'username': this.state.username,
            'phone': this.state.phone,
            'email': this.state.email,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}users${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeUsername}
                            placeholder='用户名'
                            value={this.state.username}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changePhone}
                            placeholder='电话'
                            value={this.state.phone}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeEmail}
                            placeholder='邮箱'
                            value={this.state.email}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            value={this.state.status}
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <Entity
                        policy={this.props.policy}
                        isModalOpen={this.state.isModalOpen}
                        record={this.state.record}
                        setIsModalOpen={this.setIsModalOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setIsModalOpen={this.setIsModalOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT